//      
             
                     
          
                     
                        
                     
              
             
                           
import didStartAfterCritical from '../../../did-start-after-critical';

              
                           
                                  
                                
                                    
                   
                            
   

export default ({
  isMovingForward,
  destination,
  draggables,
  combine,
  afterCritical,
}      )          => {
  if (!destination.isCombineEnabled) {
    return null;
  }
  const combineId              = combine.draggableId;
  const combineWith                     = draggables[combineId];
  const combineWithIndex         = combineWith.descriptor.index;
  const didCombineWithStartAfterCritical          = didStartAfterCritical(
    combineId,
    afterCritical,
  );

  if (didCombineWithStartAfterCritical) {
    if (isMovingForward) {
      return combineWithIndex;
    }
    return combineWithIndex - 1;
  }

  if (isMovingForward) {
    return combineWithIndex + 1;
  }

  return combineWithIndex;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/move-in-direction/move-to-next-place/move-to-next-index/from-combine.js